import React from 'react';

type Props = {
    iconName: string;
    bgColor?: string;
    fillColor?: string;
    height?: number;
    width?: number;
};

const SvgIcon = React.memo(function SvgIcon({
    iconName = 'pause',
    bgColor = 'none',
    fillColor = '#fff',
    height = 24,
    width = 24,
}: Props) {
    /**
     * The path for the icons is derived from the material icons source code.
     * prop `height` and `width` control the size of the icons.
     */
    const containerPath = `M0 0h${24}v${24}H0z`;

    const svgIconTemplateMapping: Record<string, string> = {
        play_arrow: 'M8 5v14l11-7z',
        pause: 'M6 19h4V5H6v14zm8-14v14h4V5h-4z',
        replay: 'M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z',
        stop: 'M6 6h12v12H6z',
        volume_off:
            'M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z',
        volume_on:
            'M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z',
    };

    let iconTemplate = null;

    if (Object.prototype.hasOwnProperty.call(svgIconTemplateMapping, iconName)) {
        iconTemplate = svgIconTemplateMapping[iconName];
    } else {
        return;
    }

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={height}
            viewBox="0 0 24 24"
            width={width}
            fill={fillColor}
        >
            <path d={containerPath} fill={bgColor} />
            <path d={iconTemplate} />
        </svg>
    );
});

export default SvgIcon;
